module.exports = vendor_lib;